<template>
    <div class="user_wrap">


        <img src="../images/share/pbg.png" class="myteam-bg">

        <div class="top_header">
            <div class="user_detail">
                <div class="user_header">
                    <img src="../images/avt.png" alt="">
                </div>
                <div class="user_name">
                    <p class="user_nickname">
                        <span>{{ data.nickname }}</span>
                        <!-- <img @click="$router.push('/edit')" src="../images/user/edit2.png"
                            style="width:0.4rem;margin-left:10px" alt=""> -->
                    </p>
                    <p class="user_vip">
                        <span>{{ data.id }}</span>
                        <img @click="doCopy(data.id)" src="../images/share/copy.png" style="width:0.35rem;margin-left:15px"
                            alt="">
                    </p>
                </div>
            </div>
        </div>

        <!-- <p class="tips">Saldo < 0.40, Rollover se tornará 0 após 60 segundos</p> -->

        <div class="asset-wrap">

            <div class="asset-top">
                <div class="asset-top-left">
                    <p class="total-asset">{{ $t('总资产') }}</p>
                    <p class="total-number">${{ data.money }}</p>
                </div>

                <div class="asset-top-right" @click="$router.push('/invest')">
                    <button class="recharge-btn">{{ $t('查看钱包') }}</button>
                    <img src="../images/user/jiantou.png" alt="" class="jiantou" />
                </div>
            </div>
            <div class="asset-btm">
                <div class="btm-item">
                    <p class="item-money">{{ $t('钱符') }} {{ data.today_bet_amount }}</p>
                    <p class="item-des">Valor da aposta de hoje</p>
                </div>
                <!-- <div class="btm-item">
              <p class="item-money">{{ $t('钱符') }} {{ to2(data.typing_amount_limit - data.typing_amount) }}</p>
              <p class="item-des">{{ $t('打码要求') }}</p>
            </div> -->
                <div class="btm-item">
                    <p class="item-money">{{ $t('钱符') }} {{ formatNumberToTwoDecimalPlaces(data.today_bet_amount * 0.005) }}</p>
                    <p class="item-des">A recompensa de amanhã</p>
                </div>
            </div>

        </div>

        <!--        <div class="raw">-->
        <!--            <div class="re" @click="$router.push('/invest')">-->
        <!--                <img src="../images/user/re.png" alt="">-->
        <!--                <p>{{ $t('我要充值') }}</p>-->

        <!--            </div>-->
        <!--            <div class="re" @click="$router.push('/cash')">-->
        <!--                <div>{{ $t('我要提现') }}</div>-->
        <!--                <img src="../images/user/wd.png" alt="">-->
        <!--            </div>-->
        <!--        </div>-->

        <div class="user_yw">
            <div class="re" @click="$router.push('/cash')">
                <img src="../images/user/wd.png" alt="">
                <p>{{ $t('我要提现') }}</p>
            </div>
            <div class="re" @click="$router.push('/invest')">
                <img src="../images/user/re.png" alt="">
                <p>{{ $t('我要充值') }}</p>
            </div>
            <div @click="$router.push('/bet_list')">
                <img src="../images/user/bet.png" alt="" />
                <p>Ordem</p>
            </div>
            <div @click="$router.push('/myteam')" style="position: relative;">
                <img src="../images/user/team.png" alt="" />
                <p>{{ $t('我的团队') }}</p>
            </div>

        </div>
        <div class="user_uu">
            <div @click="goService()" style="position: ;relative">
                <img src="../images/user/service.png" alt="" />
                <p>{{ $t('在线客服') }}</p>
                <img src="../images/user/jiantou.png" alt="" class="jiantou" />
            </div>
            <div @click="$router.push('/moneybag')">
                <img src="../images/user/recharge_list.png" alt="" />
                <p>{{ $t('充值记录') }}</p>
                <img src="../images/user/jiantou.png" alt="" class="jiantou" />
            </div>
            <div @click="$router.push('/cashlist')">
                <img src="../images/user/wd_list.png" alt="" />
                <p>{{ $t('提现记录') }}</p>
                <img src="../images/user/jiantou.png" alt="" class="jiantou" />
            </div>
            <div @click="logout()">
                <img src="../images/user/exit.png" alt="" />
                <p>{{ $t('退出') }}</p>
                <img src="../images/user/jiantou.png" alt="" class="jiantou" />
            </div>
        </div>
        <ft></ft>
    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import ft from "../../components/ft.vue"
import {
    Icon,
    Cell,
    CellGroup
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon);

export default {
    name: "user",
    components: {
        ft
    },
    data() {
        return {
            data: {},
            eye: 1,
        };
    },
    created() {
        this.$parent.footer('user');
    },
    mounted() {
        this.start();
    },
    methods: {
        formatNumberToTwoDecimalPlaces(input) {
            // 检查输入是否是数字
            if (typeof input !== 'number') {
                return '0.00';
            }

            // 使用 toFixed 方法保留两位小数并将其转换为字符串
            return input.toFixed(2);
        },
        to2(num) {
            try {
                return Math.ceil(num * 100) / 100;
            } catch (error) {
                return Math.ceil(num * 100) / 100;
            }


        },
        start() {
            Fetch('/user/getUserInfoAPi').then((r) => {
                //console.log(r);
                this.data = r.data;

            });
        },
        goService() {
            let u = navigator.userAgent;
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
            if (isIOS) {
                window.location.href = this.data.service;
            }
            else {
                window.open(this.data.service);
            }
        },
        getAvat(phone) {
            return require('../images/avat/' + phone % 20 + ".png");
        },
        logout() {
            Fetch('/user/logout').then((r) => {
                //console.log(r);
                if (r.code == 1) {
                    this.$router.push("/");
                    localStorage.removeItem('token')
                }
            });
        },
        doCopy(val) {
            let _this = this;
            this.$copyText(String(val)).then(
                function (e) {
                    _this.$toast({
                        background: "#07c160",
                        message: _this.$t("复制成功"),
                    });
                },
                function (e) {
                    // console.log(e);
                }
            );
        },


    }
};
</script>

<style lang="less" scoped>
.myteam-bg {
    width: 100%;
    // height: 5rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
}
.tips {
    font-size: 0.34rem;
    color: gold;
    width: 95%;
    margin: 1px auto 15px;
    text-align: center;
    align-items: center;
    font-weight: 700;
    margin-top: 10px;
    background: #0d7319;
    height: 20px;
    padding: 5px;
}

.funcs {
    width: 95%;
    display: flex;
    margin: 1px auto 10px;
    justify-content: space-between;
}

.raw {
    width: 95%;
    display: flex;
    margin: 1px auto 5px;
    justify-content: space-between;
}

.raw .re {
    width: 48%;
    display: flex;
    justify-content: space-around;
    padding: 25px 10px;
    align-content: center;
    align-items: center;
    height: 1.8rem;
    color: #84A559;
    background: #0d7319;
    box-sizing: border-box;
    font-size: 0.4rem;
    font-weight: 700;
   
}

.raw .re img {
    width: 35px;
}

.van-cell::after {
    border: 1px solid #344064;
}

.van-cell {
    background: rgb(43, 56, 100);
    color: white;
}

.user_wrap {
    background: url(../images/vip/sbg.png);
    padding-top: 1.2rem;
}

.set_go {
    width: 38px;
    height: 38px;
    position: absolute;
    top: 11px;
    right: 60px;
    background: url(../images/user/sign.png) no-repeat center center;
    background-size: 75% 75%;
}

.setting-btn {
    width: 38px;
    height: 38px;
    position: absolute;
    top: 11px;
    right: 14px;
    background: url(../images/setting.png) no-repeat center center;
    background-size: 60% 60%;
}

.user_nickname {
    height: 30px;
    line-height: 30px;
    font-size: 0.45rem;
    font-weight: bold;
    text-indent: 10px;
    position: relative;
    margin: 0 auto;
    color: #84A559;
}

.user_vip {
    height: 30px;
    line-height: 30px;
    font-size: 0.35rem;
    text-indent: 10px;
    position: relative;
    margin: 0 auto;
    color: #84A559;
    font-weight: normal;
    margin-top: 5px;
}

.top_header {
    position: relative;
    width: 100%;
    //background: cornflowerblue;
    background-size: 100% 100%;


}

.user_detail::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: .3;
}

.user_detail {
    width: 95%;
    margin: 0 auto;
    margin-top: 10px;
    padding: 15px 3% 10px 3%;
    align-items: center;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 10px;
    overflow: hidden;

    .user_header {
        position: relative;
        margin: 0 auto;
        width: 2rem;
        height: 2rem;
        overflow: hidden;
        align-items: center;
        border-radius: 50%;
        border: 3px solid #84A559;
        img {
            width: 100%;
            height: 100%;
        }
    }

    .user_name {
        margin-left: 3px;
        margin-top: 3px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        color: #FFFFFF;


    }
}

.asset-wrap {
    width: 95%;
    margin: 3px auto 10px;
    border-radius: 15px;
    border: 1px solid #84A559;
    z-index: 999;
    background-size: cover;
    border-radius: 15px;
    padding: 8px 15px;
    box-sizing: border-box !important;
    padding-bottom: 0;
}

.asset-top {
    // height: 75px;
    width: 100%;
    //background: #8d8d8f;
    display: flex;
}

.asset-btm {
    height: 65px;
    width: 98%;
    margin: 15px auto;
    margin-bottom: 0;
    // background: #198325;
    display: flex;
    border-radius: 10px;
    justify-content: space-between;
}

.btm-item {
    width: 49.33%;
}

.item-money {
    text-align: center;
    height: 30px;
    line-height: 40px;
    font-weight: 700;
    font-size: 0.5rem;
    color: #84A559;
    font-size: 0.5rem;
}

.item-des {
    text-align: center;
    height: 15px;
    line-height: 15px;
    font-size: 0.3rem;
    color: #84A559;
    margin-top: 10px;
    font-family: "PingFang-SC-Medium";
}

.asset-top-left {
    width: 65%;
}

.asset-top-right {
    width: 35%;
    display: flex;
    align-items: center;
    position: relative;

    .jiantou {
        display: flex;
        position: absolute;
        right: 20px;
    }

    img {
        width: 20px;
        height: 20px;
        display: inline;
        margin-top: 1px;
        margin-right: 10px;
    }
}

.total-asset {
    height: 20px;
    line-height: 20px;
    color: #84A559;
    font-size: 0.3rem;
    font-weight: 700;
}

.total-number {
    height: 40px;
    line-height: 55px;
    color: #90d934;
    font-weight: 700;
    font-size: 0.65rem;
    // background-image: -webkit-linear-gradient(bottom, #FFB000, #FBE057);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
}

.recharge-btn {
    width: 100%;
    height: 35px;
    background: #84A559;
    border-radius: 15px;
    color: white;
    font-size: 0.38rem;
}

.user_uu {
    justify-content: space-between;
    width: 94%;
    margin: 0 auto;
    border-radius: 5px 5px 0 0;
    padding: 3px 0;
    // border: 1px solid #84A559;
    margin-bottom: 15px;
    font-size: 15px;
    position: relative;

    .jiantou {
        display: flex;
        position: absolute;
        right: 20px;
    }

    div {
        width: 90%;
        height: 1rem;
        margin: 10px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #84a55970;
    }

    p {
        color: #84A559;
        margin-top: 3px;
        //margin-right: 18px;
        display: inline
    }

    img {
        width: 20px;
        height: 20px;
        display: inline;
        margin-top: 1px;
        margin-right: 10px;
    }
}

.user_yw {
    display: flex;
    justify-content: space-between;
    text-align: center;
    width: 96%;
    // background: rgb(43, 56, 100);
    margin: 0 auto;
    border-radius: 5px 5px 0 0;
    padding: 3px 0;
    // background: #0d7319;
    margin-bottom: 15px;

    div {
        width: 31.8%;
        padding: 0 3px;
        //background: rgb(43, 56, 100);
        //height: 2rem;
        // background: #0d7319;
    }

    p {
        color: #84A559;
        margin-top: 8px;
        font-size: 0.35rem;
    }

    img {
        width: 1.5rem;
       
    }
}


.list {
    width: 96%;
    margin-left: 2%;
    margin-top: 10px;
    border-radius: 5px;
    background: rgb(43, 56, 100);

    img {
        vertical-align: middle;
        width: 22px;
        height: 20px;
        margin-right: 10px;
    }
}
</style>
